import { render } from "./Groupbuy.vue?vue&type=template&id=564e441e&scoped=true&ts=true"
import script from "./Groupbuy.vue?vue&type=script&lang=ts"
export * from "./Groupbuy.vue?vue&type=script&lang=ts"

import "./Groupbuy.vue?vue&type=style&index=0&id=564e441e&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564e441e"]])

export default __exports__